/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CommunicationMarkNotificationBadgesAsSeenMutationVariables =
  Types.Exact<{
    badges: Types.NotificationsBadgeNamesInput;
  }>;

export type CommunicationMarkNotificationBadgesAsSeenMutation = {
  __typename?: 'Mutation';
  notificationsBadgesSeen?: {
    __typename?: 'NotificationsBadgesSeenResponse';
    success?: {
      __typename?: 'NotificationsBadgesSeenData';
      response?: string | null;
    } | null;
    error?: {
      __typename?: 'NotificationsBadgesSeenError';
      message?: string | null;
      description?: string | null;
    } | null;
  } | null;
};

export const CommunicationMarkNotificationBadgesAsSeenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'CommunicationMarkNotificationBadgesAsSeen',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'badges' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NotificationsBadgeNamesInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notificationsBadgesSeen' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'badges' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'success' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'response' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CommunicationMarkNotificationBadgesAsSeenMutation,
  CommunicationMarkNotificationBadgesAsSeenMutationVariables
>;
